import _ from 'lodash'
import { t } from '@lingui/macro'

import { InsIdentity } from '@/core/types/dmp-connect'
import { isValidDate } from '@/utils/dateUtils'

/** Identity traits as recorded in the INS audit log after a successful card read. */
export function toReturnedIdentity(identity: InsIdentity) {
  return {
    insNIR: identity.Ins?.s_value && identity.Ins?.s_key ? identity.Ins.s_value + identity.Ins.s_key : undefined,
    insOID: identity.Ins?.s_oid,
    birthName: identity.s_birthName,
    birthGiven: identity.s_birthGiven,
    birthDate: identity.s_birthDate,
    sex: Number.isInteger(identity.i_sex) ? String(identity.i_sex) : undefined,
    birthPlaceCode: identity.s_birthPlace,
    insHistory: identity.History?.map((history) => ({
      value: history.s_value,
      key: history.s_key,
      oid: history.s_oid,
      startDate: history.s_startDate,
      endDate: history.s_endDate,
    })),
  }
}

/** Traits INSi returned that are missing or malformed and prevent using the identity. */
export function getInsIdentityErrors(identity: InsIdentity): string[] {
  const errors: string[] = []
  if (!isValidDate(identity.s_birthDate)) errors.push(t`The birth date ${identity.s_birthDate} is invalid for this patient`)
  if (_.isEmpty(identity.s_birthName)) errors.push(t`The birth name is empty for this patient`)
  if (_.isEmpty(identity.s_birthGiven)) errors.push(t`The birth given is empty for this patient`)
  if (!Number.isInteger(identity.i_sex)) errors.push(t`The sex is empty for this patient`)
  return errors
}
